<template>
  <div>
    <div>
      <div
        v-if="quotaLeave.length <= 0"
        class="d-flex align-items-center justify-content-center"
        style="height: 250px"
      >
        <div class="d-flex flex-column align-items-center">
          <img
            :src="require('@/assets/icon/info.png')"
            width="60"
            height="60"
          >
          <h6>Data is empty</h6>
          <h6>Your leave type has not been setup</h6>
        </div>
      </div>
      <div
        v-for="item in quotaLeave"
        v-else
        :key="item.id"
        class="mt-3"
      >
        <label class="bold w-50 mb-0 text-truncate">
          <img
            :src="item.icon_url"
            width="20"
            height="20"
          >
          {{ item.name }}
        </label>
        <label class="float-right">
          {{ `(${$moment(item.start_date).format('DD MMM YYYY')}
          -
          ${$moment(item.end_date).format('DD MMM YYYY')})` }}
        </label>
        <b-progress
          :max="item.quota === 0 ? 1 : item.quota"
          class="mt-1"
        >
          <b-progress-bar
            :value="item.usage"
            style="background-color: #2487E1 !important"
            variant="primary">
            <span
              :class="((item.usage/item.quota)*100) > 5 ? 'label-used' : 'label-used-null'"
              style="position:absolute; margin-left: 5px;">
              Used: {{ item.usage }}
            </span>
          </b-progress-bar>
          <b-progress-bar
            :value="item.quota === 0 ? 1 : item.quota - item.usage"
            style="background-color: #D3D3D3 !important"
            variant="secondary">
            <span
              :class="((item.quota - item.usage)/item.quota)*100 > 6 ?
              'label-remaining' : 'label-remaining-null'"
              style="position:absolute; right:15px; margin-right: 5px;">
              Remaining: {{ item.quota - item.usage }}
            </span>
          </b-progress-bar>
        </b-progress>
      </div>
      <div/>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    element: {
      type: Object,
      default: () => {},
    },
    quotaLeave: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
};
</script>

<style lang="scss">
  .label-used {
    color: white !important;
    mix-blend-mode: normal;
  }
  .label-used-null {
    color: gray !important;
    mix-blend-mode: normal;
  }
  .label-remaining {
    color: gray !important;
    mix-blend-mode: normal;
  }
  .label-remaining-null {
    color: white !important;
    mix-blend-mode: normal;
  }
</style>



// WEBPACK FOOTER //
// src/views/widget/widget-card/jQuotaLeaveWidget.vue